import { db } from '../firebase';
import { createActionAuditEntry } from './actionAudit';
import { deleteNotificationWithCounters } from './notificationCounters';

// Dismiss, done where every card decision that works in production is done.
//
// Both dismiss controls used to POST /api/dismiss-notification. That route is
// deployed nowhere a browser can reach: the host the client had hardcoded is
// served by `exports.api`, the sheet-creation function, which has no router and
// answered 400 "Missing required fields" to every click, and the real Flask
// route lives in EmailAutomation-webhook/app.py, which no reachable service
// serves - `process-user` admits a single service account, so no URL change
// makes the call work. Mark Handled was moved off it first (DEF-13); this is
// the same move for Dismiss.
//
// Two writes, and nothing else:
//   1. an audit row saying a human dismissed this and that nothing was sent;
//   2. the counter-safe delete of that one card.
//
// The THREAD is not touched. The server route also stopped the conversation,
// cancelled its outbox items and cleared the sheet highlight; none of that is
// reproduced here, because a client-side "stop" is a different decision from
// the one this control offers. The sidebar's own copy says "Clear this
// notification" - removal, not stopping - and the Stop control on the
// conversation is what ends a thread.
//
// firestore.rules accepts an owner-written actionAudit create only with status
// in queued/dismissed/stopped/completed, and "dismissed" is exactly what this
// decision is, so the rules need no change.

export const DISMISS_ACTION_TYPE = 'dismiss';
export const DISMISS_AUDIT_STATUS = 'dismissed';
export const SIDEBAR_DISMISS_SOURCE = 'dashboard_sidebar_dismiss';

export async function dismissNotificationOnClient({
  uid,
  client,
  clientId,
  notification,
  notificationId,
  source = SIDEBAR_DISMISS_SOURCE
}) {
  const resolvedClientId = clientId || client?.id || notification?.clientId || null;
  const resolvedNotificationId = notificationId || notification?.id || null;
  if (!uid || !resolvedClientId || !resolvedNotificationId) return false;

  await createActionAuditEntry({
    uid,
    actionType: DISMISS_ACTION_TYPE,
    status: DISMISS_AUDIT_STATUS,
    source,
    client: client || { id: resolvedClientId },
    notification,
    threadId: notification?.threadId ?? null,
    rowAnchor: notification?.rowAnchor ?? notification?.meta?.rowAnchor ?? null,
    rowNumber: notification?.rowNumber ?? notification?.meta?.rowNumber ?? null,
    reason: notification?.meta?.reason ?? notification?.reason ?? null,
    sourceMessageId: notification?.meta?.sourceMessageId ?? notification?.sourceMessageId ?? null,
    // The row records a decision, not a message: nothing was drafted and
    // nothing was sent.
    subject: '',
    suggestedBody: '',
    suggestedRecipients: [],
    suggestedCcRecipients: [],
    finalBody: '',
    finalRecipients: [],
    finalCcRecipients: []
  });

  return deleteNotificationWithCounters({
    db,
    uid,
    clientId: resolvedClientId,
    notificationId: resolvedNotificationId
  });
}
